import {
  Box, Button, Heading,
} from '@chakra-ui/react';

import { ApplicationList } from './components/ApplicationList';
import { InitialApplicantModal } from './components/InitialApplicantModal';
import { useModal } from 'hooks/useModal';

export function ApplicationListPage(): React.ReactNode {
  const [{ isOpen },
    {
      onClose: onCloseModal,
      onOpen: onOpenModal,
    }] = useModal({});

  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <Box
        maxWidth='1100px'
        minW='350px'
        width='100%'
      >
        <Heading fontSize={30} mb={10}>Applications</Heading>
        <Box
          display='flex'
          mb='25px'
          justifyContent='space-between'
        >
          <Button onClick={onOpenModal}>New application</Button>
          <InitialApplicantModal
            isOpen={isOpen}
            onClose={onCloseModal}
          />
        </Box>
        <ApplicationList />
      </Box>
    </Box>
  );
}
